import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AdminGuard {
  constructor(
    protected auth: AuthService,
    private router: Router,
  ) {}

  // The two failure cases need different answers. login() only helps when there is no
  // session; for a signed-in non-admin Keycloak bounces straight back with a fresh code
  // and the guard rejects again — an unbounded redirect loop against /auth.
  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.ready$.pipe(
      filter(e => !!e),
      take(1),
      map(() => {
        if (!this.auth.keycloak.token) {
          this.auth.keycloak.login();
          return false;
        }
        return this.auth.canUseSysadmin ? true : this.router.createUrlTree(['/']);
      }),
    );
  }
}
